import {
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  DialogContent,
  Typography,
  Box,
  TextField,
} from "@mui/material";
import { useTheme } from "@mui/system";
import { useFormRCAutoDetails } from "../rcautoContext";
import { useMemo, useState } from "react";
import { validateTarga } from "../../rcAuto/nuovoPreventivo/helpers";

const ConfermaSalva = ({ open, setOpen, onConfirm, onModifica }) => {
  const theme = useTheme();
  const { formState } = useFormRCAutoDetails();
  const [targa, setTarga] = useState("");

  const isPiva = Object.keys(formState.legale).length > 0;
  const { cliente } = formState;

  // Senza i tab Cliente e Veicolo non ci sono dati da verificare: si chiede solo la targa
  const hasClienteVeicolo =
    formState.tabs?.includes("Cliente") || formState.tabs?.includes("Veicolo");

  const validation = useMemo(() => {
    if (!cliente) return { hasAddress: false, hasContacts: false };

    // Check address fields: slResIndirizzoVia, slResIndirizzo, slResCap, slResCivico
    const hasAddress =
      cliente.slResIndirizzoVia &&
      cliente.slResIndirizzo &&
      cliente.slResCap &&
      cliente.slResCivico;

    // Check contacts: idTipologia 3 (Cellulare) and 1 (Email) both predefinito = 1
    const hasCell = cliente.contatti?.some(
      (c) => c.idTipologia === 3 && c.predefinito === 1 && c.valore,
    );
    const hasEmail = cliente.contatti?.some(
      (c) => c.idTipologia === 1 && c.predefinito === 1 && c.valore,
    );

    return {
      hasAddress: !!hasAddress,
      hasContacts: !!(hasCell && hasEmail),
      cellMissing: !hasCell,
      emailMissing: !hasEmail,
    };
  }, [cliente]);

  const isTargaValida = validateTarga(targa);
  const canProceed = hasClienteVeicolo
    ? validation.hasAddress && validation.hasContacts
    : isTargaValida;

  const handleClose = () => {
    setOpen(false);
    setTarga("");
  };

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="sm"
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            backgroundColor:
              theme.palette.mode === "dark" ? "#1B2635" : "#F7F9FC",
          },
        },
      }}
    >
      <DialogTitle sx={{ fontWeight: "bold", fontSize: "1.5rem" }}>
        Salva preventivo
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          Si sta procedendo a salvare il preventivo.
        </Typography>

        {hasClienteVeicolo ? (
          <>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Prima di procedere verificare la correttezza di questi dati:
            </Typography>

            <Box sx={{ pl: 2, mb: 2 }}>
              <Typography
                variant="body1"
                sx={{
                  color: validation.hasAddress ? "success.main" : "error.main",
                  fontWeight: 500,
                }}
              >
                • {isPiva ? "Sede legale" : "Indirizzo"}:{" "}
                {validation.hasAddress
                  ? `${cliente.slResIndirizzoVia} ${cliente.slResIndirizzo}, ${cliente.slResCivico} - ${cliente.slResCap}`
                  : "Indirizzo mancante"}
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  color: validation.hasContacts ? "success.main" : "error.main",
                  fontWeight: 500,
                  mt: 1,
                }}
              >
                • Email:{" "}
                {validation.hasContacts
                  ? cliente.contatti.find(
                      (el) => el.idTipologia === 3 && el.predefinito === 1,
                    ).valore
                  : "integrare informazione"}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: validation.hasContacts ? "success.main" : "error.main",
                  fontWeight: 500,
                  mt: 1,
                }}
              >
                • Cellulare:{" "}
                {validation.hasContacts
                  ? cliente.contatti.find(
                      (el) => el.idTipologia === 1 && el.predefinito === 1,
                    ).valore
                  : "integrare informazione"}
              </Typography>
            </Box>
          </>
        ) : (
          <>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Inserire la targa del veicolo:
            </Typography>
            <TextField
              autoFocus
              label="Targa"
              value={targa}
              onChange={(e) => setTarga(e.target.value.toUpperCase())}
              error={targa !== "" && !isTargaValida}
              helperText={
                targa !== "" && !isTargaValida ? "Targa non valida" : ""
              }
            />
          </>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <Button onClick={handleClose} color="inherit" variant="outlined">
          Chiudi
        </Button>
        {hasClienteVeicolo && (
          <Button
            onClick={onModifica}
            color="primary"
            variant="outlined"
            sx={{ mx: 2 }}
          >
            Modifica dati
          </Button>
        )}
        <Button
          onClick={() => onConfirm(hasClienteVeicolo ? undefined : targa)}
          color="primary"
          variant="contained"
          disabled={!canProceed} //Richiama la funzione che salva tutti i dati, poi l'api che salva il preventivo
        >
          Procedi
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfermaSalva;
